const invoiceTypes = {
    FETCH_INVOICES: 'FETCH_INVOICES',
    FETCH_INVOICES_START: 'FETCH_INVOICES_START',
    FETCH_CUSTOMER_INVOICES: 'FETCH_CUSTOMER_INVOICES',
    FETCH_CUSTOMER_INVOICES_START: 'FETCH_CUSTOMER_INVOICES_START',
}

export default invoiceTypes;
